export class ConfirmationResponse {
  uuid: string;
  comunicationResponse: CommunicationResponse;
}

export class CommunicationResponse {
  code: CommunicationError;
  type: CommunicationType;
  success: boolean;
  service: string; // "WALLET",
  destination: string; // ex: phone number
}

export enum CommunicationError {
  WALLET_INSUFFICIENT_BALANCE = 'WALLET_INSUFFICIENT_BALANCE',
}

export enum CommunicationType {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}



// WEBPACK FOOTER //
// ./src/app/shared/models/communication-response.model.ts